<div class="row ">
  <div class="col-12">
    <h1>{{title}} - Failed Users</h1>
    <div class="mb-2">
      <re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>
    </div>
  </div>
</div>
<div class="row mt-1">
  <div class="col-12">
    <button type="button" (click)="back()" class="btn btn-default">Back</button>
  </div>
</div>

<div class="row mt-3">
  <div class="col-12">
    <table class="table table-striped table-hover table-bordered">
      <thead>
        <tr>
          <th>UserName</th>
          <th>SSOID</th>
          <th>Reason</th>
        </tr>

      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td>{{item.userName}}</td>
          <td>{{ hideSsoId ? '' : item.ssoId }}</td>
          <td>{{item.failedReason}}</td>
        </tr>
      </tbody>
    </table>
  </div>

</div>
